export const ORGANIZATION_DELETE_TITLE = "Delete Organization — Permanent Action";

export const ORGANIZATION_DELETE_WARNING =
  "WARNING: Deleting this organization will permanently remove ALL related data from the database. " +
  "This includes HR records (employees, exits, leaves, attendance, payroll), user accounts, roles, permissions, " +
  "departments, locations, EMS data (students, leads, admissions, batches, fees, certificates, training programs), " +
  "PM project data, and every other record where organization_id is linked. " +
  "This action cannot be undone.";
